module.exports = __webpack_public_path__ + "img/13-6.010b9777.jpg";